export default "__VITE_ASSET__870e5e2d__"